import * as deepEqual from 'deep-equal';
var events = [
    'beforeEdit',
    'cancel',
    'cellClose',
    'change',
    'columnHide',
    'columnLock',
    'columnMenuInit',
    'columnMenuOpen',
    'columnReorder',
    'columnResize',
    'columnShow',
    'columnUnlock',
    'dataBinding',
    'dataBound',
    'detailCollapse',
    'detailExpand',
    'detailInit',
    'edit',
    'excelExport',
    'filter',
    'group',
    'groupCollapse',
    'groupExpand',
    'page',
    'pdfExport',
    'filterMenuInit',
    'filterMenuOpen',
    'remove',
    'save',
    'saveChanges',
    'sort',
    'navigate'
];
var configuration = [
    'allowCopy',
    'autoBind',
    'columnResizeHandleWidth',
    'columns',
    'columnMenu',
    'editable',
    'excel',
    'filterable',
    'groupable',
    'height',
    'messages',
    'mobile',
    'navigatable',
    'noRecords',
    'pageable',
    'pdf',
    'persistSelection',
    'reorderable',
    'resizable',
    'scrollable',
    'selectable',
    'sortable',
    'toolbar'
];
var reconcileEvents = function (oldEvents, newEvents, widget) {
    Object.keys(oldEvents).map(function (key) {
        widget.unbind(key, oldEvents[key]);
    });
    Object.keys(newEvents).map(function (key) {
        widget.bind(key, newEvents[key]);
    });
};
var reconcileConfiguration = function (oldConfiguration, newConfiguration, widget) {
    if (!deepEqual(oldConfiguration, newConfiguration, { strict: true })) {
        widget.setOptions(newConfiguration);
    }
};
export { configuration, events, reconcileEvents, reconcileConfiguration };
//# sourceMappingURL=util.js.map